import { render, staticRenderFns } from "./Indices.vue?vue&type=template&id=ecdc1fc8&scoped=true"
import script from "./Indices.vue?vue&type=script&lang=js"
export * from "./Indices.vue?vue&type=script&lang=js"
import style0 from "./Indices.vue?vue&type=style&index=0&id=ecdc1fc8&prod&lang=scss&scoped=true"
import style1 from "./Indices.vue?vue&type=style&index=1&id=ecdc1fc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdc1fc8",
  null
  
)

export default component.exports